import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Avatar,
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { Teams } from '@par/shared/types/game';
import { DbLeagueTeam } from '@par/shared/types/league';
import { fetchGet, fetchPost } from '@par/shared/api/common';

type PropTypes = {
  close: () => void;
  open: boolean;
  profileId: string;
};

export const LeagueAddWeekScheduleDialog = ({
  close,
  open,
  profileId,
}: PropTypes) => {
  const theme = useTheme();
  const [startDate, setStartDate] = useState<Dayjs | null>();
  const [endDate, setEndDate] = useState<Dayjs | null>();
  const [week, setWeek] = useState(1);
  const [season, setSeason] = useState(0);

  const handleAddScheduleClick = async () => {
    if (!startDate || !endDate) return;
    const res = await fetchPost('/league/add-week-schedule', {
      profileId,
      startDate: startDate.valueOf(),
      endDate: endDate.valueOf(),
      season: season,
      week: week,
    });
    console.log('handleAddScheduleClick', res);
    close();
  };

  const handleWeekChange = (event: SelectChangeEvent) => {
    setWeek(+event.target.value);
  };

  const handleSeasonChange = (event: SelectChangeEvent) => {
    setSeason(+event.target.value);
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>Add a week schedule</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <FormControl variant="standard" sx={{ minWidth: 100 }}>
              <InputLabel>Season</InputLabel>
              <Select value={season.toString()} onChange={handleSeasonChange}>
                <MenuItem value={0}>Pilot</MenuItem>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
              </Select>
            </FormControl>
            <FormControl variant="standard" sx={{ minWidth: 100 }}>
              <InputLabel>Week</InputLabel>
              <Select value={week.toString()} onChange={handleWeekChange}>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
              </Select>
            </FormControl>
          </Stack>
          <Stack direction="row" spacing={2}>
            <Stack spacing={1}>
              <Typography>Week Start Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                />
              </LocalizationProvider>
            </Stack>
            <Stack spacing={1}>
              <Typography>Week End Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                />
              </LocalizationProvider>
            </Stack>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} fullWidth>
          Cancel
        </Button>
        <Button onClick={handleAddScheduleClick} fullWidth>
          Add Week Schedule
        </Button>
      </DialogActions>
    </Dialog>
  );
};
